import React from 'react';


const Error = () => (
  <div>Error 404</div>
);

export default Error;
